import React, { useEffect, useState } from "react";
import { Formik, useFormik, Field, Form, ErrorMessage } from "formik";
import { timeSheetValidationSchema } from "../../../components/Helpers";
import Hoc from "../../../components/HOC";
import ModalComponent from "../../../components/Modal";
import Select from "react-select";
import CustomDropdown from "../../../components/CustomDropdown";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import CustomDatePicker from "../../../components/CustomDatePicker";
import TextInput from "../../../components/TextInput";
import { toast } from "react-toastify";
import MuiDatePicker from "../../../components/MuiDatePicker";
import { time } from "framer-motion";

const TimeSheet = ({
  onClose,
  show,
  onAddTimeSheet,
  title,
  timesheetValues,
  projectsList,
}) => {
  const [holidays, setHolidays] = useState([]);
  const timesheetByIdReducer = useSelector(
    (state) => state.GetTimesheetByIdReducer
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(true);

  const dispatch = useDispatch();
  const addHoliday = () => {
    setHolidays([...holidays, { employee_holiday_date: "", notes: "" }]);
  };

  const removeHoliday = (index) => {
    setHolidays(holidays.filter((_, i) => i !== index));
  };
  const handleSubmit = (values, { resetForm }) => {
    const timeSheetData = {
      ...values,
      projectId: values.projectId.id || values.projectId,
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
      holidays,
    };

    onAddTimeSheet(timeSheetData, selectedFile);
  };

  // const handleSubmit = (values, { resetForm }) => {
  //   const timeSheetData = {
  //     ...values,
  //     projectId: values.projectId.id,
  //     startDate: moment(values.startDate).format("yyyy-MM-DD"),
  //     endDate: moment(values.endDate).format("yyyy-MM-DD"),
  //     holidays,
  //   };
  //   onAddTimeSheet(timeSheetData, selectedFile);
  // };

  const handleClose = () => {
    setIsAddModalOpen(false);
    setHolidays([]);
    setSelectedFile(null);
    onClose();
  };

  useEffect(() => {
    if (!timesheetByIdReducer?.Loading && timesheetByIdReducer?.Response) {
      setHolidays(
        timesheetByIdReducer.Response.holidays.map((holiday) => ({
          employee_holiday_date: holiday.employee_holiday_date,
          notes: holiday.notes,
        }))
      );
      setSelectedFile(timesheetByIdReducer.Response.files[0]);
    }
  }, [timesheetByIdReducer]);

  const updateHoliday = (index, field, value) => {
    const updatedHolidays = holidays.map((holiday, i) =>
      i === index ? { ...holiday, [field]: value } : holiday
    );
    setHolidays(updatedHolidays);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
    const file = event.dataTransfer.files[0];
    if (
      file &&
      [
        ".xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ].includes(file.type)
    ) {
      setSelectedFile(file);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleDeleteFile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedFile(null);
  };

  const uploadFile = () => {
    if (selectedFile) {
      // dispatch(requestUploadFileAction({ file: selectedFile }));
    }
  };

  console.log(projectsList, "initial");
  return (
    <ModalComponent show={show} onClose={handleClose} title={title}>
      <Formik
        initialValues={timesheetValues}
        enableReinitialize
        // validationSchema={timeSheetValidationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        }) => {
          const isProjectEnded =
            values?.endDate && moment().isAfter(moment(values?.endDate));
          return (
            <Form className="max-h-[85vh] overflow-y-scroll no-scrollbar p-2 md:p-4">
              <>
                <div
                  className={`grid gap-4 mb-3 ${
                    timesheetValues?.status === "REJ"
                      ? "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
                      : "grid-cols-1 md:grid-cols-2"
                  }`}
                >
                  <div className="w-full">
                    <CustomDropdown
                      value={projectsList.find(
                        (project) =>
                          project.id === values?.projectId?.id ||
                          values?.projectId
                      )}
                      customClasses="w-full text-left"
                      name="projectId"
                      handleChange={(selectedOption) => {
                        setFieldValue("projectId", selectedOption);
                      }}
                      placeholder="Select Project"
                      options={projectsList}
                      handleGetOptionValue={(option) => option.id}
                      handleGetOptionName={(option) => option.projectName}
                      isDisabled={title === "Edit Timesheet"}
                    />
                    <ErrorMessage
                      name="projectId"
                      component="div"
                      className="text-red-500"
                    />
                  </div>

                  <div className="w-full">
                    <CustomDropdown
                      value={[
                        { value: "Office", label: "Office" },
                        { value: "Remote", label: "Remote" },
                      ].find(
                        (work_location) =>
                          work_location.value === values?.work_location
                      )} 
                      customClasses="w-full text-left"
                      name="work_location"
                      handleChange={(selectedOption) => {
                        setFieldValue("work_location", selectedOption?.value);
                      }}
                      placeholder="Select work location"
                      options={[
                        { value: "Office", label: "Office" },
                        { value: "Remote", label: "Remote" },
                      ]}
                      handleGetOptionValue={(option) => option.value}
                      handleGetOptionName={(option) => option.label}
                      isDisabled={title === "Edit Timesheet"}
                    />
                    <ErrorMessage
                      name="work_location"
                      component="div"
                      className="text-red-500"
                    />
                  </div>

                  {timesheetValues?.status === "REJ" && (
                    <div className="w-full">
                      {/* <label className="text-sm font-sm text-gray-700 block">
                        Rejection Remarks
                      </label> */}
                      <textarea
                        placeholder="Rejection Remarks"
                        value={timesheetValues?.rejectionRemarks || timesheetValues?.remarks || ""} 
                        readOnly
                        className="w-full border border-gray-300 rounded-md p-2 h-[2.4rem] cursor-not-allowed"
                      />
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div className="w-full my-2">
                    <MuiDatePicker
                      label="Start Date"
                      value={
                        values?.startDate ? moment(values.startDate) : null
                      }
                      onChange={(date) => {
                        if (date) {
                          setFieldValue("startDate", date.format("YYYY-MM-DD"));
                          // Ensure endDate is not before the newly selected startDate
                          if (
                            values?.endDate &&
                            moment(date).isAfter(moment(values.endDate))
                          ) {
                            setFieldValue("endDate", null); // Reset endDate if it's invalid
                          }
                        }
                      }}
                      disabled={!values?.projectId}
                      minDate={
                        values?.projectId?.startDate
                          ? moment(values.projectId.startDate)
                          : null
                      }
                      maxDate={
                        values?.endDate
                          ? moment(values.endDate) // Prevent selecting a start date after the end date
                          : values?.projectId?.endDate
                          ? moment(values.projectId.endDate)
                          : null
                      }
                    />
                  </div>

                  <div className="w-full my-2">
                    <MuiDatePicker
                      label="End Date"
                      value={values?.endDate ? moment(values.endDate) : null}
                      onChange={(date) => {
                        if (date) {
                          setFieldValue("endDate", date.format("YYYY-MM-DD"));
                        }
                      }}
                      disabled={!values?.projectId}
                      minDate={
                        values?.startDate
                          ? moment(values.startDate) // Ensuring endDate cannot be before startDate
                          : values?.projectId?.startDate
                          ? moment(values.projectId.startDate)
                          : null
                      }
                      maxDate={
                        values?.projectId?.endDate
                          ? moment(values.projectId.endDate)
                          : null
                      }
                    />
                  </div>

                  <div className="w-full my-2">
                    <TextInput
                      value={values?.total_hours}
                      name="total_hours"
                      placeholder="total hours"
                      handleChange={handleChange}
                      type="number"
                      classes="w-full"
                      legend
                    />
                    <ErrorMessage
                      name="total_hours"
                      component="div"
                      className="text-red-500"
                    />
                  </div>
                </div>

                <div className="col-span-1 w-full mt-4">
                  <div className="flex items-center gap-3">
                    <label className="text-sm font-sm text-gray-700">
                      Holidays
                    </label>
                    <button
                      type="button"
                      className="px-3 py-1.5 font-bold text-white bg-primary hover:bg-primaryDark rounded-md transition-all"
                      onClick={addHoliday}
                    >
                      +
                    </button>
                  </div>

                  <div
                    className={`mt-3 space-y-3 ${
                      holidays.length > 2
                        ? "max-h-[150px] overflow-y-auto border rounded-lg p-2"
                        : ""
                    }`}
                  >
                    {holidays.length > 0 ? (
                      holidays.map((holiday, index) => (
                        <div
                          key={index}
                          className="flex flex-col md:flex-row items-start md:items-center gap-3"
                        >
                          <div className="w-full">
                            {/* <label className="text-sm font-medium text-gray-700">
                              On Date
                            </label> */}
                            <MuiDatePicker
                            label="On Date"
                              value={
                                holiday.employee_holiday_date
                                  ? moment(holiday.employee_holiday_date)
                                  : null
                              }
                              onChange={(date) => {
                                if (date) {
                                  updateHoliday(
                                    index,
                                    "employee_holiday_date",
                                    date.format("YYYY-MM-DD")
                                  );
                                }
                              }}
                              minDate={
                                values?.startDate
                                  ? moment(values.startDate)
                                  : null
                              }
                              maxDate={
                                values?.endDate ? moment(values.endDate) : null
                              }
                              disabled={!values.startDate || !values.endDate}
                            />
                          </div>

                          <div className="w-full">
                            {/* <label className="text-sm font-sm text-gray-700">
                              Note
                            </label> */}
                            <TextInput
                              type="text"
                              name={`holidays[${index}].notes`}
                              value={holiday.notes}
                              className="p-2 border border-gray-300 rounded-md w-full"
                              placeholder="Enter note"
                              onChange={(e) =>
                                updateHoliday(index, "notes", e.target.value)
                              }
                              legend
                            />
                          </div>

                          <button
                            type="button"
                            className="px-4 py-2 text-white bg-red-500 hover:bg-red-600 rounded-md transition-all"
                            onClick={() => removeHoliday(index)}
                          >
                            &times;
                          </button>
                        </div>
                      ))
                    ) : (
                      <div className="text-gray-500 text-sm text-center mt-2">
                        No holidays added
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className="flex items-center justify-center w-full py-2"
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                >
                  <label
                    htmlFor="dropzone-file"
                    className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600 hover:bg-gray-light "
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                        <span className="font-semibold">
                          Click to upload or drag and drop{" "}
                        </span>
                      </p>
                      {selectedFile && (
                        <div className="text-sm text-gray-500 flex dark:text-gray-400 mt-2 mr-2">
                          Selected file:{" "}
                          <span className="px-5 text-primary">
                            {" "}
                            {selectedFile.name || selectedFile?.fileName}{" "}
                          </span>{" "}
                          <button onClick={handleDeleteFile}>
                            <svg
                              className="w-6 h-6 text-danger bg-red-500 rounded-full p-1"
                              aria-hidden="true"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M3 6h18v2H3V6zm2 3h14v12a2 2 0 01-2 2H7a2 2 0 01-2-2V9zm3 2v8h2v-8H8zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zM9 4V2h6v2h5v2H4V4h5z"
                              />
                            </svg>
                          </button>
                        </div>
                      )}
                    </div>
                    <input
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                      accept={[
                        ".xlsx",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      ].join(",")}
                      onChange={handleFileChange}
                    />
                  </label>
                </div>

                <div className="flex justify-end mt-4">
                  <button
                    type="submit"
                    className="bg-primary text-white px-4 py-1 h-10 w-full sm:w-40 rounded-lg hover:bg-primaryDark"
                  >
                    Submit
                  </button>
                </div>
              </>
            </Form>
          );
        }}
      </Formik>
    </ModalComponent>
  );
};

export default TimeSheet;
